import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons'
import { type ReactElement, useState } from 'react'
import { Alert } from '~/components/Global/Interactions/Alert/Alert'
import { AlertVariation } from '~/components/Global/Interactions/Alert/AlertVariation'
import { Button } from '~/components/Global/Interactions/Button/Button'
import { ButtonVariation } from '~/components/Global/Interactions/Button/ButtonVariation'
import type { GlobalMessage } from '../../types'
import { GlobalMessageModal } from '../GlobalMessageModal/GlobalMessageModal'

type GlobalMessageBannerProps = {
  message: GlobalMessage
  onDismiss: () => void
}

export const GlobalMessageBanner = ({
  message,
  onDismiss
}: GlobalMessageBannerProps): ReactElement => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <Alert
      variation={
        message.level === 'danger'
          ? AlertVariation.Danger
          : AlertVariation.Warning
      }
      icon={faTriangleExclamation}
      message={message.message}
      onDismiss={onDismiss}
    >
      {message.description !== null && (
        <>
          <Button
            variation={ButtonVariation.Link}
            buttonSize="small"
            onClick={() => setIsModalOpen(true)}
          >
            En savoir plus
          </Button>
          <GlobalMessageModal
            message={message}
            description={message.description}
            open={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          />
        </>
      )}
    </Alert>
  )
}
